import './horizontalBanner.css';

export default function Row (props) {
    return (
        <div className="horizontalBanner">
            {props.children}
        </div>
    );
}
